import { z } from 'zod'
import { ADJUSTMENT_CHARGE_TYPE, ADJUSTMENT_REASON_TYPE, AdjustmentReasonType } from '@/services/settlement/settlementManagement/types'

export const getAdjustmentSchema = (isReasonRequired: (value: AdjustmentReasonType) => boolean) => {
  return z
    .object({
      partnerId: z.string(),
      settlementBaseType: z.enum(['PARTNER', 'MUSINSA_LOGISTICS']),
      settlementMonth: z.string().nonempty(),
      adjustmentReasonType: z.enum(ADJUSTMENT_REASON_TYPE),
      adjustmentChargeType: z.enum(ADJUSTMENT_CHARGE_TYPE),
      adjustmentAmount: z // MEMO: 최댓값이 MAX_SAFE_INTEGER를 넘어가게 되어 의도대로 입력이 안되는 경우 발생 -> string으로 받도록 수정
        .string({ message: '1원 이상 입력해 주세요.' })
        .max(15, '999,999,999,999,999까지 입력할 수 있어요.')
        .refine((val) => val !== '' && Number(val) >= 1, {
          message: '1원 이상 입력해 주세요.',
        }),
      adjustmentCount: z
        .string()
        .max(9, '999,999,999까지 입력할 수 있어요.')
        .refine((val) => val === '' || Number(val) >= 1, {
          message: '1건 이상 입력해 주세요.',
        })
        .optional(),
      adjustmentReason: z.string().max(200, '최대 200자까지 입력할 수 있어요.').optional(),
      isContinue: z.boolean(),
    })
    .superRefine((data, ctx) => {
      if (isReasonRequired(data.adjustmentReasonType) && !data.adjustmentReason?.trim()) {
        ctx.addIssue({
          path: ['adjustmentReason'],
          code: z.ZodIssueCode.custom,
        })
      }
    })
}
export type AdjustmentFormValues = z.infer<ReturnType<typeof getAdjustmentSchema>>
